import React from "react";

const SESSION_FLAG = "wakilniResetPasswordRedirectAttempted";

class RedirectToAppResetPassword extends React.Component {
  componentDidMount() {
    const { token, email, resetKey } = this.props;
    if (!token || !email || !resetKey) return;

    if (sessionStorage.getItem(SESSION_FLAG)) return;

    const userAgent = navigator.userAgent.toLowerCase();
    const isAndroid = /android/.test(userAgent);
    const isIOS = /iphone|ipad|ipod/.test(userAgent);

    if (!isAndroid && !isIOS) return;

    sessionStorage.setItem(SESSION_FLAG, "true");

    const params = `token=${encodeURIComponent(token)}&email=${encodeURIComponent(
      email,
    )}&key=${encodeURIComponent(resetKey)}`;
    const appLink = `wakilni://reset-password?${params}`;

    if (isAndroid) {
      window.location.href = `intent://reset-password?${params}#Intent;scheme=wakilni;package=com.wakilni.customer;S.browser_fallback_url=${encodeURIComponent(
        window.location.href,
      )};end`;
    } else if (isIOS) {
      window.location.assign(appLink);
    }
  }

  render() {
    return null;
  }
}

export default RedirectToAppResetPassword;
